import CloseIcon from "@mui/icons-material/Close";
import {
  Alert,
  Box,
  Button,
  IconButton,
  Modal,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import axios from "../../config/authaxios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  background: "#fff",
  boxShadow: 24,
  padding: 20,
  borderRadius: "8px",
};

export default function DeleteDiscount({
  open,
  setOpen,
  discountId,
  sku,
  isDeleted = false,
  onDeleted,
}) {
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const isRestore = isDeleted === true || isDeleted === "true";
  const handleClose = () => setOpen(false);

  const handleConfirm = () => {
    setLoading(true);
    axios
      .delete(`/admin/discount/${discountId}`, {
        data: { is_deleted: !isRestore },
      })
      .then((res) => {
        if (res.data.status_code === 401) {
          localStorage.clear();
          return;
        }
        if (res.data.status) {
          setSnackbar({
            open: true,
            message:
              res.data.message ||
              (isRestore ? "Restored successfully" : "Deleted successfully"),
            severity: "success",
          });
          onDeleted?.();
          handleClose();
        } else {
          setSnackbar({
            open: true,
            message: res.data.message || (isRestore ? "Restore failed" : "Delete failed"),
            severity: "error",
          });
        }
      })
      .catch(() => {
        setSnackbar({ open: true, message: "Something went wrong", severity: "error" });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Stack direction="row" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">
              {isRestore ? "Restore Discount Config" : "Delete Discount Config"}
            </Typography>
            <IconButton onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Stack>
          <Typography mb={2}>
            Are you sure you want to {isRestore ? "restore" : "delete"} the discount config for SKU{" "}
            <strong>{sku}</strong>?
          </Typography>
          {!isRestore && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              This will soft-delete the config. You can restore it later from the deleted list.
            </Alert>
          )}
          <Stack direction="row" spacing={2}>
            <Button
              variant="contained"
              color={isRestore ? "success" : "error"}
              onClick={handleConfirm}
              disabled={loading}
            >
              {loading
                ? isRestore
                  ? "Restoring..."
                  : "Deleting..."
                : isRestore
                  ? "Restore"
                  : "Delete"}
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              Cancel
            </Button>
          </Stack>
        </Box>
      </Modal>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar((s) => ({ ...s, open: false }))}
      >
        <Alert severity={snackbar.severity} sx={{ width: "100%" }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
